import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ04 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO SECTION */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage: "url('/Images/tour/e5097041-1fb_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Golden Triangle with Ajmer Pushkar (AITP / RJ-04)</h1>

            <p className="hero-subtitle">
              5 Nights / 6 Days • Delhi – Agra – Jaipur – Ajmer – Pushkar
            </p>

            <div className="hero-price">
              Starting From <span>₹18,500*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + ENQUIRY */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/189d7899-cf2_big.jpg" alt="" />
                <img src="/Images/tour/e5097041-1fb_big.jpg" alt="" />
                <img src="/Images/tour/a46bc2c8-e32_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹18,500*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Triangle Tour with Ajmer Pushkar</h1>
              <p>Delhi • Agra • Jaipur • Ajmer • Pushkar | 5 Nights / 6 Days</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Delhi Heritage Tour</Col>
                <Col md={6}>✔ Taj Mahal Agra</Col>
                <Col md={6}>✔ Agra Fort</Col>
                <Col md={6}>✔ Fatehpur Sikri</Col>
                <Col md={6}>✔ Amber Fort Jaipur</Col>
                <Col md={6}>✔ Ajmer Dargah Sharif</Col>
                <Col md={6}>✔ Pushkar Brahma Temple</Col>
                <Col md={6}>✔ Pushkar Lake</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Discover India’s iconic Golden Triangle along with the
                spiritual destinations of Ajmer and Pushkar. Experience
                Mughal architecture, royal palaces, sacred temples and
                vibrant Rajasthan culture during this memorable journey.
              </p>
            </div>

            {/* ITINERARY */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Delhi</Accordion.Header>
                  <Accordion.Body>
                    Arrival pickup and hotel check-in. Visit Jama Masjid,
                    India Gate, Qutub Minar, Humayun's Tomb, Raj Ghat,
                    Parliament House and Connaught Place. Overnight stay
                    in Delhi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Day 2 – Delhi to Agra</Accordion.Header>
                  <Accordion.Body>
                    Drive to Agra via Mathura & Vrindavan temples.
                    Visit Taj Mahal, Agra Fort and Itimad-Ud-Daulah Tomb.
                    Overnight stay in Agra.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Agra to Jaipur via Fatehpur Sikri
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Fatehpur Sikri en route to Jaipur.
                    Hotel check-in and overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Day 4 – Jaipur Sightseeing</Accordion.Header>
                  <Accordion.Body>
                    Visit Amber Fort, Jal Mahal, City Palace,
                    Jantar Mantar and Hawa Mahal. Evening shopping
                    at local markets. Overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Jaipur – Ajmer – Pushkar
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Ajmer and visit Ajmer Dargah Sharif.
                    Continue to Pushkar to visit Brahma Temple
                    and Pushkar Lake. Return to Jaipur for
                    overnight stay.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    Day 6 – Jaipur to Delhi Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    After breakfast depart for Delhi.
                    Drop at airport or railway station.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* INCLUSION / EXCLUSION */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Vehicle</li>
                    <li>All Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument Entry Fees</li>
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                    <li>Lunch & Tips</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* HOTEL */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Comfortable deluxe category hotels in Delhi, Agra
                and Jaipur offering modern amenities and relaxing stay.
              </p>
            </div>

            {/* RATE */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹18,500 per person on twin sharing basis.
                Rates may vary depending on travel dates and season.
              </p>
            </div>

            {/* TERMS */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>Advance payment required.</li>
                <li>Cancellation policy applicable.</li>
              </ul>
            </div>

            {/* TRAVEL TIPS */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry valid ID proof.</li>
                <li>Best travel season: Oct – March.</li>
                <li>Wear comfortable footwear.</li>
                <li>Respect local religious customs.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ04;